import { cn } from "@/lib/utils"

interface PriceWithTaxProps {
  baseFee: string | number
  tax: string | number
  total?: number
  className?: string
}

export function PriceWithTax({ baseFee, tax, total, className }: PriceWithTaxProps) {
  const calculatedTotal = total ?? Number(baseFee || 0) + Number(tax || 0)

  return (
    <div className={cn("flex justify-end text-sm", className)}>
      <span className="text-slate-400 font-semibold">
        （¥{baseFee || "0"} + 税¥{tax || "0"} ）
      </span>
      <span className="ml-2 text-slate-600 font-semibold">¥{calculatedTotal.toLocaleString()}</span>
    </div>
  )
}
